import React, { useState, useEffect, useReducer, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import { IMAGES } from "../constants/theme";

import Collapse from "react-bootstrap/Collapse";
import { MenuListArray2 } from "./MenuListArray2";
import { HashLink } from "react-router-hash-link";

const Header = () => {
  const [headerFix, setHeaderFix] = useState(false);
  
  useEffect(() => {
    window.addEventListener("scroll", () => {
      setHeaderFix(window.scrollY > 50);
    });
  }, []);
  return (
    <>
      <header className="site-header mo-left header header-transparent style-1">
        <div className="top-bar"></div>
        <div
          className={`sticky-header main-bar-wraper navbar-expand-lg ${
            headerFix ? "is-fixed" : ""
          }`}
        >
          <Mainheader />
        </div>
        {/* <!-- Main Header End --> */}
      </header>
    </>
  );
};

export default Header;

export const Mainheader = () => {
  /* for sticky header */

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState("");
  const location = useLocation();

  useEffect(() => {
    var mainMenu = document.getElementById("OpenMenu");
    if (mainMenu) {
      if (sidebarOpen) {
        mainMenu.classList.add("show");
      } else {
        mainMenu.classList.remove("show");
      }
    }
  });

  // Menu dropdown list
  const reducer = (previousState, updatedState) => ({
    ...previousState,
    ...updatedState,
  });
  const initialState = {
    active: "",
    activeSubmenu: "",
  };
  const [state, setState] = useReducer(reducer, initialState);
  const handleMenuActive = (status) => {
    setState({ active: status });
    if (state.active === status) {
      setState({ active: "" });
    }
  };
  const handleSubmenuActive = (status) => {
    setState({ activeSubmenu: status });
    if (state.activeSubmenu === status) {
      setState({ activeSubmenu: "" });
    }
  };

  function AddActiveMenu() {
    MenuListArray2?.forEach((ell) => {
      if (ell.to === location.pathname) {
        setActiveMenu(ell.title);
      }
      ell.content?.forEach((ele) => {
        if (ele.to === location.pathname) {
          setActiveMenu(ell.title);
        }
      });
    });
  }
  useMemo(AddActiveMenu, [location.pathname]);

  return (
    <>
      <div className="main-bar clearfix">
        <div className="container clearfix">
          <div className="box-header clearfix">
            {/* <!-- Website Logo --> */}
            <div className="logo-header mostion logo-dark">
              <a href={"/"}>
                <img
                  className="select_logo"
                  src={IMAGES.logoHorizontal}
                  alt="Performance Hub"
                  style={{
                    height: "auto",
                    width: "auto",
                    padding: "10px 0",
                    margin: "0 auto",
                    display: "block",
                  }}
                />
              </a>
            </div>

            <button
              className={`navbar-toggler navicon justify-content-end ${
                sidebarOpen ? "open" : "collapsed"
              }`}
              type="button"
              onClick={() => setSidebarOpen(!sidebarOpen)}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>

            {/* <!-- Extra Nav --> */}
            <div className="extra-nav">
              <div className="extra-cell">
                <a
                  id="quik-search-btn"
                  type="button"
                  className="header-search-btn"
                  href="https://www.instagram.com/performancehub_australia/?hl=es"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="fa-brands fa-instagram"></i>
                </a>
                <Link
                  to={"/services"}
                  className="btn btn-primary btn-skew appointment-btn"
                >
                  <span>Book Now</span>
                </Link>
              </div>
            </div>
            {/* <!-- Extra Nav --> */}

            {/* <!-- Header Nav --> */}
            <div
              id="navbarNavDropdown"
              className={`header-nav navbar-collapse collapse justify-content-end ${
                sidebarOpen ? "show" : ""
              }`}
            >
              <div className="logo-header logo-dark">
                <a href={"/"}>
                  <img
                    className="select_logo"
                    src={IMAGES.logoHorizontal}
                    alt="Performance Hub"
                    style={{
                      height: "auto",
                      width: "auto",

                      margin: "0 auto",
                      display: "block",
                    }}
                  />
                </a>
              </div>
              <ul className="nav navbar-nav navbar navbar-left">
                {MenuListArray2.map((item, index) => {
                  let menuClass = item.classChange;
                  if (menuClass !== "sub-menu-down") {
                    return (
                      <li
                        className={`${menuClass} ${
                          location.pathname + location.hash === item.to
                            ? "active"
                            : ""
                        }`}
                        key={index}
                      >
                        {index === 0 ? (
                          <a href="/">Home</a>
                        ) : (
                          <HashLink
                            smooth
                            to={item.to}
                            onClick={() => setSidebarOpen(false)}
                          >
                            {item.title}
                          </HashLink>
                        )}
                      </li>
                    );
                  } else {
                    return (
                      <li
                        className={`${menuClass} ${
                          state.active === item.title ? "open active" : ""
                        } ${item.title === activeMenu ? "active" : ""}`}
                        // <li className={`${ menuClass} ${ location.pathname == item.to ? 'active'  : '' }`}
                        key={index}
                      >
                        {item.content && item.content.length > 0 ? (
                          <>
                            <Link
                              to={"#"}
                              onClick={() => {
                                handleMenuActive(item.title);
                              }}
                            >
                              {item.title}
                            </Link>
                            <Collapse
                              in={state.active === item.title ? true : false}
                            >
                              <ul
                                className={`sub-menu ${
                                  menuClass === "mm-collapse" ? "open" : ""
                                }`}
                              >
                                {item.content &&
                                  item.content.map((data, index) => {
                                    return (
                                      <li
                                        key={index}
                                        className={`${
                                          state.activeSubmenu === data.title
                                            ? "open"
                                            : ""
                                        }`}
                                        //className={`${ menuClass} ${ location.pathname == data.to ? 'active'  : '' }`}
                                      >
                                        {data.content &&
                                        data.content.length > 0 ? (
                                          <>
                                            <Link
                                              to={data.to}
                                              onClick={() => {
                                                handleSubmenuActive(data.title);
                                                setSidebarOpen(false);
                                              }}
                                            >
                                              {data.title}
                                              <i className="fa fa-angle-right" />
                                            </Link>
                                            <Collapse
                                              in={
                                                state.activeSubmenu ===
                                                data.title
                                                  ? true
                                                  : false
                                              }
                                            >
                                              <ul
                                                className={`sub-menu ${
                                                  menuClass === "mm-collapse"
                                                    ? "open"
                                                    : ""
                                                }`}
                                              >
                                                {data.content &&
                                                  data.content.map(
                                                    (data, index) => {
                                                      return (
                                                        <>
                                                          <li key={index}>
                                                            <Link
                                                              to={data.to}
                                                              onClick={() => {
                                                                handleSubmenuActive(
                                                                  data.title
                                                                );
                                                                setSidebarOpen(
                                                                  false
                                                                );
                                                              }}
                                                            >
                                                              {data.title}
                                                            </Link>
                                                          </li>
                                                        </>
                                                      );
                                                    }
                                                  )}
                                              </ul>
                                            </Collapse>
                                          </>
                                        ) : (
                                          <Link
                                            onClick={() => {
                                              handleSubmenuActive(data.title);
                                              setSidebarOpen(false);
                                            }}
                                            to={data.to}
                                          >
                                            {data.title}
                                          </Link>
                                        )}
                                      </li>
                                    );
                                  })}
                              </ul>
                            </Collapse>
                          </>
                        ) : (
                          <Link to={item.to}>{item.title}</Link>
                        )}
                      </li>
                    );
                  }
                })}
              </ul>
              <div className="dz-social-icon">
                <ul>
                  <li>
                    <Link
                      target="_blank"
                      to="https://www.instagram.com/performancehub_australia/?hl=es"
                      rel="noreferrer"
                    >
                      <i className="fab fa-instagram"></i>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
